import { createContext } from 'react';

const initialLoadingContext: LoadingContextStore = {
  isLoading: false,
  setIsLoading: () => {},
};

export const LoadingContext = createContext<LoadingContextStore>(initialLoadingContext);
